import { createSlice } from "@reduxjs/toolkit";
import { FULLFILLED } from "@root/constants";
import {
  ADMIN_CREATE_USER_ACTION,
  ADMIN_USERS_MANAGEMENT_ACTION,
} from "@root/store/action-types/admin/userManagement";



const INITIAL_STATE: UsersState = {
  users: {
    rows: [],
    count: 0,
  },
};

export const usersMangementSlice = createSlice({
  name: "usersMangement",
  initialState: INITIAL_STATE,
  reducers: {
    updateAdminUsers: (state, { payload }) => {
      state.users = payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(
      `${ADMIN_USERS_MANAGEMENT_ACTION}${FULLFILLED}`,
      (state, { payload }: any) => {
        if (payload) {
          state.users = payload;
        }
        return state;
      }
    );

    builder.addCase(
      `${ADMIN_CREATE_USER_ACTION}${FULLFILLED}`,
      (state, { payload }: any) => {
        if (payload) {
          state?.users?.rows?.push(payload);
        }
      }
    );
  },
});

export const { updateAdminUsers } = usersMangementSlice.actions;

export const adminUsersManagementReducer = usersMangementSlice.reducer;
